import UserJoinButton from "components/join/UserJoinButton";
import { ThemeChanger } from "features/ThemeManager";
import useCurrentUser from "hooks/fragments/useCurrentUser";

import LogoutLinkActive from "../parts/LogoutLink/LogoutLinkActive";
import PricingLink from "../UserMenu/PricingLink";

import UserMenu from "./UserMenu/UserMenu";

export default function UserSpecificMenu() {
  const { isLoggedIn, isOnboarded, pro } = useCurrentUser(u => {
    return {
      isOnboarded: u?.onboarded || false,
      pro: u?.pro || false,
      isLoggedIn: u?.id > 0,
    };
  });
  return (
    <>
      {!isLoggedIn ? (
        <>
          <ThemeChanger />
          <UserJoinButton variant="primary" tab="Login">
            <>Login</>
          </UserJoinButton>
        </>
      ) : (
        <>
          {isOnboarded ? (
            <>
              {!pro && <PricingLink />}
              <UserMenu />
            </>
          ) : (
            <LogoutLinkActive />
          )}
        </>
      )}
    </>
  );
}
